import { gql } from '@apollo/client'

export const GET_HUMAN_RESOURCES = gql`
  query GetHumanResources($searchQuery: String, $limit: Int, $offset: Int) {
    getHumanResources(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      rows {
        id
        name
        last_name
        photograph_id
        photographFile {
          id
          url
        }
        HumanResourcesToAttachments {
          id
          human_resources_id
          file_id
        }
      }
      count
    }
  }
`

export const GET_HUMAN_RESOURCE_BY_ID = gql`
  query GetHumanResourceById($id: Int) {
    getHumanResourceById(id: $id) {
      id
      name
      last_name
      photograph_id
      photographFile {
        id
        url
      }
      HumanResourcesToAttachments {
        id
        human_resources_id
        file_id
        attachmentFile {
          id
          url
        }
      }
    }
  }
`

export const CREATE_HUMAN_RESOURCES = gql`
  mutation CreateHumanResources($input: InputHumanResources!) {
    createHumanResources(input: $input)
  }
`

export const UPDATE_HUMAN_RESOURCES = gql`
  mutation UpdateHumanResources($id: Int!, $input: InputHumanResources!) {
    updateHumanResources(id: $id, input: $input)
  }
`

export const DELETE_HUMAN_RESOURCES = gql`
  mutation DeleteHumanResources($id: Int!) {
    deleteHumanResources(id: $id)
  }
`
